import { atom } from "recoil";
import { ocPersistAtom } from "oc/states/persist-atom";

export const taxDeclarationPersonalState = atom({
  key: "taxDeclarationPersonalState",
  default: {
    dateOfDeclaration: new Date(),
    isModifiedDeclaration: false,
    disabledStateFrom: "",
    disabledStateTo: "",
    isFinal: false,
    disabilityPension: false,
    disabilityPensionNumber: "",
    disabilitySupport: false,
    disabilitySupportNumber: "",
    applyToWithdrawal: false,
    noRequestRelief: false,
  },
  effects_UNSTABLE: [ocPersistAtom],
});
